import ThemeCache from './ThemeCache.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/defineProperty';
import '../../../../../../rc-util@5.44.4_react-dom@18.3.1_react@18.3.1/node_modules/rc-util/es/warning.js';

new ThemeCache();
